import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { CommonModule } from '@angular/common'

@Component({
  selector: 'app-template-apply-dialog',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
  templateUrl: './template-apply-dialog.component.html',
  styleUrls: ['./template-apply-dialog.component.scss'],
})
export class TemplateApplyDialogComponent {
  @Input() isOpen = false
  @Input() templateName = ''

  @Output() closed = new EventEmitter<void>()
  @Output() confirmed = new EventEmitter<void>()
}
